import {gql} from '@apollo/client';
import {useCallback} from 'react';
import Arts, {GqlArtFragment} from 'src/components/Arts';
import {useQuery} from 'src/hooks';
import InfiniteScroll from './InfiniteScroll';
import {QueryNewArts} from './__generated__/QueryNewArts';

const PAGE_LIMIT = 20;

const GQL_ARTS = gql`
  query QueryNewArts($first: Int!, $skip: Int!) {
    arts(
      first: $first
      skip: $skip
      subgraphError: allow
      orderBy: mintedAt
      orderDirection: desc
      where: {mintedAt_gt: 0}
    ) {
      ...ArtFragment
    }
  }
  ${GqlArtFragment}
`;

export default function ExploreArts() {
  const {data, loading, fetchMore} = useQuery<QueryNewArts>(GQL_ARTS, {
    variables: {
      first: PAGE_LIMIT,
      skip: 0,
    },
  });

  const handleLoadMore = useCallback(async () => {
    const result = await fetchMore({variables: {skip: data?.arts?.length}});
    return result.data?.arts;
  }, [data, fetchMore]);

  return (
    <>
      <h1>Recently Minted Art</h1>
      <InfiniteScroll
        pageLimit={PAGE_LIMIT}
        data={data?.arts}
        onLoadMore={handleLoadMore}
        loading={loading}
        children={(arts) => <Arts arts={arts} />}
      />
    </>
  );
}
